/**
 * Utility to know if something is an array.
 */
export function isArray(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
}
